export const CustomerRequestKeys = {
  ValidateCustomer: 'validate-customer',
  RegisterCustomer: 'register-customer'
} as const;

export type CustomerRequestKey =
  (typeof CustomerRequestKeys)[keyof typeof CustomerRequestKeys];
